import {Component, 
    OnInit, 
    ElementRef, 
    ViewChildren, 
    ViewChild, 
    ChangeDetectionStrategy, 
    ChangeDetectorRef, 
    Inject, 
	ViewRef
} 
from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service
import { NhapKhoVer2Service } from '../phieu-nhap-kho-ver2-service/phieu-nhap-kho-ver2.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { ChiTietPhieuNhapKho, PhieuNhapKho, NguoiThucHienNhapKho } from '../phieu-nhap-kho-ver2-model/phieu-nhap-kho-ver2.model';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { DeNghiNhapKhoChiTiet } from '../../kho-phieu-thong-tin-hang-ve/phieu-thong-tin-hang-ve-ver2-model/phieu-thong-tin-hang-ve-ver2.model';
import moment from 'moment';
import { JsPDFFontService } from '../../../dung-chung/__services/pdf-custom-font.service';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
//Component

@Component({
	selector: 'm-phieu-nhap-kho-ver2-detail',
	templateUrl: './phieu-nhap-kho-ver2-detail.component.html',
	styleUrls: ['../phieu-nhap-kho-ver2.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class PhieuNhapKhoDetailVer2Component implements OnInit{

	/*Config Form */
	CONFIG: CommonConFig;
	
    /* Các trường focus cho các tag trong form */
	@ViewChildren('focus') focus ;
	@ViewChildren('focusNCC') focusNCC;
	@ViewChildren('focusQC') focusQC;
	@ViewChildren('focusNVNH') focusNVNH;
	@ViewChildren('focusKho') focusKho;
    @ViewChildren('focusGhiChu') focusGhiChu;

    /* Comment columns mat-table
    Các trường columns cho bảng:
    - displayedColumns: display ra form
    - availableColumns: các cột sẽ được add vào display.
    - extendsColumns: các cột mở rộng thêm cho display khi QC kiểm tra
	*/
	displayedColumns = [];
	availableColumns = [
		{
			stt: 0,
            name: 'select',
            displayName: 'Check chọn',
			alwaysChecked: true,
			isShow: true
        },
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongthucnhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 7,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 10,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'SoMay',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'NgaySanXat',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 13,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'LyDoChoPhepXuat',
            displayName: 'Lý do cho phép xuất',
            alwaysChecked: false,
			isShow: true
		}
	];
	tmpAvailableColumns = [
		{
			stt: 0,
            name: 'select',
            displayName: 'Check chọn',
			alwaysChecked: true,
			isShow: true
        },
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongthucnhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 7,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 10,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'SoMay',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'NgaySanXat',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 13,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'LyDoChoPhepXuat',
            displayName: 'Lý do cho phép xuất',
            alwaysChecked: false,
			isShow: true
		},
	];
	phieuTTHVColumn = [
		{
			stt: 0,
            name: 'select',
            displayName: 'Check chọn',
			alwaysChecked: true,
			isShow: true
        },
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoPhieuDN',
            displayName: 'Số phiếu TTHV',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'Soluongchungtu',
            displayName: 'SLKH',
            alwaysChecked: false,
			isShow: true
		},

		{
            stt: 8,
            name: 'Soluongthucnhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Warning',
            displayName: 'Cảnh báo SL KH & CT',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 9,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 12,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 13,
            name: 'SoMay',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'NgaySanXat',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 15,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 16,
            name: 'LyDoChoPhepXuat',
            displayName: 'Lý do cho phép xuất',
            alwaysChecked: false,
			isShow: true
        }
	];
	ketQuaSXColumn = [
		{
			stt: 0,
            name: 'select',
            displayName: 'Check chọn',
			alwaysChecked: true,
			isShow: true
        },
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'LenhSX',
            displayName: 'Lệnh SX',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'Soluongkh',
            displayName: 'SLKH',
            alwaysChecked: false,
			isShow: true
		},

		{
            stt: 8,
            name: 'Soluongthucnhap',
            displayName: 'SL',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 9,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 12,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 13,
            name: 'SoMay',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'NgaySanXat',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 15,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 16,
            name: 'LyDoChoPhepXuat',
            displayName: 'Lý do cho phép xuất',
            alwaysChecked: false,
			isShow: true
        }
	];
	phieuDNNKColumn = [
		{
			stt: 0,
            name: 'select',
            displayName: 'Check chọn',
			alwaysChecked: true,
			isShow: true
        },
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoPhieuDNNK',
            displayName: 'Số phiếu ĐNNK',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoluongchungtuDNNK',
            displayName: 'SLĐN',
            alwaysChecked: false,
			isShow: true
		},

		{
            stt: 8,
            name: 'Soluongthucnhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Warning',
            displayName: 'Cảnh báo SL KH & CT',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 9,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 12,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 13,
            name: 'SoMay',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'NgaySanXat',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 15,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 16,
            name: 'LyDoChoPhepXuat',
            displayName: 'Lý do cho phép xuất',
            alwaysChecked: false,
			isShow: true
        }
	];
    
    /* Mat select search cho hàng hóa */
	listId_HH : any[] = [];
	selectId_HH : string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	/* ------------------------------------------------------------------ */
    
    /* Mat select search cho nhân viên nhận hàng - QC kiểm tra */
	listIdNV : any[] = [];
	selectIdNV : string = '';
	filteredIdNV: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdNVFilterCtrl: string = '';
	haveElementIdNV: boolean = false;
	/* ------------------------------------------------------------------ */

    /* Mat select search cho kho */
	listKho : any[] = [];
	selectKho : string = '';
	filteredKho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KhoFilterCtrl: string = '';
	haveElementKho: boolean = false;
	arrayKhoForEachHH: any[] = [];

	listKhoVer2 : any[] = [];
	selectKhoVer2 : string = '';
	filteredKhoVer2: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KhoFilterCtrlVer2: string = '';
	haveElementKhoVer2: boolean = false;
	/* ------------------------------------------------------------------ */

	/* Mat select search cho vị trí kho */
	SaveListVTK: any[] = [];
	selectVTKho : string = '';
	filteredVTKho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	VTKhoFilterCtrl: string = '';
	arrayVTKhoForEachHH: any[] = [];

	ListVTKVer2: any[] = [];
	selectVTKhoVer2: string = '';
	filteredVTKhoVer2: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	VTKhoFilterCtrlVer2: string = '';
	/* ------------------------------------------------------------------ */
	
    /* Danh sách trạng thái */
	listState : any[] = [];
	nameState: string = '';
    /* ------------------------------------------------------------------ */
    
    /* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<ChiTietPhieuNhapKho>(true, []);
    /* ------------------------------------------------------------------ */
    
    /* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
    /* ------------------------------------------------------------------ */
    
    /* Extend field:  */
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                		// Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;			// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false;    	// Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAddedNK: number[] = []		    // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false;   	// Loading khi mở dialog
	canEdit: boolean = true;			// Dialog có thể chỉnh sửa không?
    disableNewButton: boolean = true;	// Tắt nút thêm mới hàng khi chưa nhập đủ
	nameButtonDS: string = '';          // Tên button lấy danh sách theo loại phiếu
	listNguoiThucHien: string[] = [];   // Array lưu id người thực hiện
    /* ------------------------------------------------------------------ */

     /* Các Sub form trên dialog:  */
	NKForm: FormGroup;				        //Form thông tin nhập kho
	hasFormErrors: boolean = false;

	DuyetForm: FormGroup;			            //Form add hàng hóa cho phiếu
    /* ------------------------------------------------------------------ */
    
    /* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
    NKItem: PhieuNhapKho;

    /* Danh sách chi tiết hàng hóa của phiếu nhập kho:   */
    listChiTietNK: ChiTietPhieuNhapKho[] = [];
    
    /* Danh sách tạm chi tiết hàng hóa của phiếu nhập kho */
	tmpChiTietNK: ChiTietPhieuNhapKho[] = [];
	
	/* Danh sách tạm chi tiết đề nghị nhập kho để so sánh khi nhập số lượng trên lưới */
    deNghiNhapKhoResult: DeNghiNhapKhoChiTiet[] = [];
	
	//ROLES
	UPDATE = '1001100';
	LIST_ROLES_USER: [] = [];
	SHOW_BUTTON_UPDATE = new BehaviorSubject<boolean>(false);

    constructor(
		public dialogRef: MatDialogRef<PhieuNhapKhoDetailVer2Component>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private nhapKhoService: NhapKhoVer2Service,
		private dungChungService: DungChungService,
		private pdfCustomService: JsPDFFontService,
		private NKFB: FormBuilder,
		private DuyetFB: FormBuilder,
		private route: ActivatedRoute,
		public dialog: MatDialog,
		private router: Router,
		private datePipe: DatePipe,
		private tokenStorage: TokenStorage,
		private translate: TranslateService,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private el: ElementRef
    ) { 
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		this.LIST_ROLES_USER = user.roles;
		this.dialogRef.disableClose = true;
	}

    /** LOAD DATA */
	ngOnInit() {
		
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();

		/*Get data from list when open dialog */
		this.NKItem = this.data.data;
        
		/*Load all dropdown and create form */
		this.ListState();
		this.ListId_HH();
		this.createForm();

		this.SHOW_BUTTON_UPDATE.next(this.isTrueButton(this.UPDATE));

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
			this.changeDetect.detectChanges();
		});
		
		if(this.NKForm.controls['LoaiPhieu'].value == 'Nhập kho hàng NCC giao'){
			this.availableColumns = this.phieuTTHVColumn
		}
		else if(this.NKForm.controls['LoaiPhieu'].value == 'Nhập kho từ kết quả sản xuất'){
			this.availableColumns = this.ketQuaSXColumn
		}
		else if(this.NKForm.controls['LoaiPhieu'].value == 'Nhập kho hàng đề nghị'){
			this.availableColumns = this.phieuDNNKColumn
		}
		else{
			this.availableColumns = this.tmpAvailableColumns
		}
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
        
		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
    }

    /*Create Form with appropriate sub forms */
	createForm(){
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		this.NKItem.Nguoitao = +idUser;
		
		let listName = '';
		if(this.NKItem.IdNk > 0){
			this.NKItem.listNguoiThucHien.forEach(element =>{
				listName += element.TenNguoiThucHien + ', ';
			})
		}
		listName = listName.substring(0, listName.length - 2);

		/*Group các Form */
		this.NKForm = this.NKFB.group({
			SoPhieu: [!(this.NKItem.Sophieu == undefined || this.NKItem.Sophieu == '') ? this.NKItem.Sophieu : '', Validators.required],
			NgayLapPhieu: [!(this.NKItem.Ngaytao == undefined || this.NKItem.Ngaytao == '') ? this.NKItem.Ngaytao : new Date(), Validators.required],
			TenNguoiLap: [this.NKItem.IdNk > 0 ? this.NKItem.TenNguoitao : tenNguoiLap],
            TrangThai: [this.nameState],
            LoaiPhieu: [!(this.NKItem.LoaiPhieu == undefined || this.NKItem.LoaiPhieu == '')? this.NKItem.LoaiPhieu : 'Nhập kho hàng NCC giao', Validators.required],
            NgayNhapKho: [!(this.NKItem.Ngaynhapkho == undefined || this.NKItem.Ngaynhapkho == '') ? this.NKItem.Ngaynhapkho : new Date(), Validators.required],
            DSNguoiThucHien: [listName,Validators.required],
            DienGiai: [!(this.NKItem.DienGiai == undefined || this.NKItem.DienGiai == '') ? this.NKItem.DienGiai : '']
		});
		/*Disable các trường dữ liệu không thay đổi */
        this.NKForm.disable();
		/*------------------------------------------------------------------*/
		
		// this.DuyetForm = this.DuyetFB.group({
        //     NguoiXacNhan: [(this.NKItem.Nguoixacnhan != null && this.NKItem.Nguoixacnhan > 0) ? this.NKItem.TenNguoixacnhan : ''],
		// 	NgayXacNhan: [!(this.NKItem.Ngayxacnhan == undefined || this.NKItem.Ngayxacnhan == '') ? this.getFormatDate(this.NKItem.Ngayxacnhan) : '' ],
		// 	LyDo: [!(this.NKItem.LyDo == undefined || this.NKItem.LyDo == '') ? this.NKItem.LyDo : '']
		// })
		// /*Disable các trường dữ liệu không thay đổi */
		// this.DuyetForm.disable();
		/*------------------------------------------------------------------*/

		/*Add dữ liệu chi tiết*/
		if(this.NKItem.listChiTietPhieuNhapKho.length > 0){
			this.listChiTietNK = this.NKItem.listChiTietPhieuNhapKho;
			this.tmpChiTietNK = [];
			for(let i = 0; i < this.listChiTietNK.length; i++){
				let tmpElement = new ChiTietPhieuNhapKho();
				tmpElement.copy(this.listChiTietNK[i])
				this.tmpChiTietNK.push(tmpElement);
			}
	
			this.tmpChiTietNK = [...this.tmpChiTietNK];
        }
		
        this.nameButtonDS = this.getNameButtonDS();
        this.changeDetect.detectChanges();
    }
    
    /*Hàm thông báo lỗi cho form tương ứng */
	onAlertFormClose($event) {
		this.hasFormErrors = false;
	}
    /*---------------------------------------- */
    
    /*Lấy tiêu đề cho dialog*/
	getTitle(): string {
		return `Chi tiết phiếu nhập kho `;
    }
    getNameButtonDS(): string{
        if(this.NKForm.controls["LoaiPhieu"].value == 'Nhập kho hàng NCC giao'){
            return 'Chọn hàng từ phiếu thông tin hàng về';
        }
        else if(this.NKForm.controls["LoaiPhieu"].value == 'Nhập kho từ kết quả sản xuất'){
            return 'Chọn hàng từ kết quả sản xuất';
        }
        return '';
    }
    
    /*Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng*/
    showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	changeValueOfColumn(columnName:string, item:any, event: any, afterUpdate: boolean, index: number){
		
		if(columnName == 'Soluongthucnhap'){
			if(afterUpdate)
				this.tmpChiTietNK[this.tmpChiTietNK.indexOf(item)].Soluongthucnhap = this.formatNumber(item.Soluongthucnhap);
			else if(!afterUpdate ){
				let indexOfItem = this.tmpChiTietNK.indexOf(item);				
				let _index = this.deNghiNhapKhoResult.findIndex(x => x.IdHh == this.tmpChiTietNK[indexOfItem].IdHh 
																	&& x.IdKho == this.tmpChiTietNK[indexOfItem].IdKho
																	&& x.Solo == this.tmpChiTietNK[indexOfItem].Solo
																	&& x.Handung == this.tmpChiTietNK[indexOfItem].Handung)

				let cal = Number(event.target.value.trim());
				if(!Number.isNaN(cal) && _index > -1 && Number(this.deNghiNhapKhoResult[_index].Soluongchungtu) < cal){
					this.layoutUtilsService.showErorr('Số lượng nhập không thể lớn hơn số lượng hàng về');
					return null;
				}
				else{
					this.tmpChiTietNK[this.tmpChiTietNK.indexOf(item)].Soluongthucnhap = event.target.value.trim();
					this.afterChangeRecord(item,index)
				}
			}
		}
		else if(columnName == 'Solo'){
			if(afterUpdate)
				this.listChiTietNK[this.tmpChiTietNK.indexOf(item)].Solo = item.Solo
			else if(!afterUpdate){
				this.tmpChiTietNK[this.tmpChiTietNK.indexOf(item)].Solo = event.target.value.trim();
				this.afterChangeRecord(item,index)
			}
		}
		else if(columnName == 'LyDoChoPhepXuat'){
			if(afterUpdate)
				this.listChiTietNK[this.tmpChiTietNK.indexOf(item)].LyDoChoPhepXuat = item.LyDoChoPhepXuat
			else if(!afterUpdate){
				this.tmpChiTietNK[this.tmpChiTietNK.indexOf(item)].LyDoChoPhepXuat = event.target.value.trim();
				this.afterChangeRecord(item,index)
			}
		}
	}
	afterChangeRecord(item:ChiTietPhieuNhapKho, index: number){
		
		let isContain = false;
		for(let i = 0; i < this.tmpChiTietNK.length; i++){
			if(index != i && item.IdHh == this.tmpChiTietNK[i].IdHh 
				&& item.IdKho == this.tmpChiTietNK[i].IdKho
				&& item.Solo == this.tmpChiTietNK[i].Solo
				&& this.getFormatDate(item.Handung) == this.getFormatDate(this.tmpChiTietNK[i].Handung)
				&& item.ViTriKho == this.tmpChiTietNK[i].ViTriKho){
					this.tmpChiTietNK[i].Soluongthucnhap = '' + (Number(item.Soluongthucnhap) 
														+ Number(this.tmpChiTietNK[i].Soluongthucnhap));
					isContain = true;
					break;
			}
		}
		if(isContain){
			this.tmpChiTietNK.splice(index, 1);
			this.arrayKhoForEachHH.splice(index, 1);
			this.arrayVTKhoForEachHH.splice(index, 1);
			this.SaveListVTK.splice(index, 1);

			this.tmpChiTietNK = [...this.tmpChiTietNK];
			this.changeDetectView();
		}
	}
	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.tmpChiTietNK.length
		return numSelected === numRows;
	}
	masterToggle() {
		if (this.isAllSelected()) {
			this.selection.clear();
		} else {
			this.tmpChiTietNK.forEach(row => {
				this.selection.select(row)		
			});
		}
	}
    /*---------------------------------------------------------------------------------------- */
    
    /*Hàm lấy danh sách trạng thái phiếu*/
	ListState(){
		this.dungChungService.listState(PhieuNhapKho.category_path).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetect.detectChanges();
			};
		});
	}
	checkState(){
		this.listState.forEach(element => {
			if(element.Code == this.NKItem.Tinhtrang){
				this.nameState = element.Description;
				if(this.NKForm != null)
					this.NKForm.controls["TrangThai"].setValue(this.nameState);
			}
		});
	}
	/*---------------------------------------- */
	
	/*Các hàm hỗ trợ cho mat select search Hàng hóa*/
	ListId_HH(){
		this.dungChungService.listHangHoa().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetectView();
			};
		});
	}
	checkCanPhieuKT(idHH: any){
		let index = this.listId_HH.findIndex(x => x.Id_HH == idHH)
		if(index > -1 && this.listId_HH[index].CanPhieuKT != null 
			&& this.listId_HH[index].CanPhieuKT != undefined && !this.listId_HH[index].CanPhieuKT){
			return true;
		}
		return false;
	}
	valueCheckboxChange(index:number, event: any){
		if(event != null && event != undefined)
			this.tmpChiTietNK[index].Tinhtrang = event.checked;
	}
	/*------------------------------------------ */
    
    /*Hàm hỗ trợ format các dạng số trên form*/
	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == '.'){
					count += 1;
				}
			}
		}
		else{
			event = "" + event
			for(let i = 0; i < event.length; i++){
				if(event[i] == '.'){
					count += 1;
				}
			}
		}
		;
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string){
		if(item == '' || item == null || item == undefined)	return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	lpad(value, padding) {
		var zeroes = new Array(padding+1).join("0");
		return (zeroes + value).slice(-padding);
	}
	/*------------------------------------------------------------- */

	/*Hàm hỗ trợ format các dạng ngày trên form*/
	getFormatDate(v: string = '') {
        if (v != undefined && v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	minMaxDate(p_Val: any, item: any) {
		
		let d1 = new Date(p_Val);
		let d2 = new Date();

		if (d1.getTime() < d2.getTime()){
			this.tmpChiTietNK[this.tmpChiTietNK.indexOf(item)].Handung =  moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
			this.tmpChiTietNK = [...this.tmpChiTietNK];
		}
		this.changeDetect.detectChanges();
	}
    /*------------------------------------------------------------- */
    
    /*Đóng dialog và cập nhập lại tình trạng, trả về highlight ID nếu có*/
	back(){
		this.dialogRef.close(
			{ 
				isChange: this.isChange,		//Dữ liệu có thay đổi hay không?
				dataAdd : this.saveAddedNK,
			}
		);
	}
	onSubmit(){
		for(let i = 0; i < this.tmpChiTietNK.length; i++){
			if(!this.tmpChiTietNK[i].isError){
				if(!this.checkCanPhieuKT(this.tmpChiTietNK[i].IdHh) && this.tmpChiTietNK[i].Tinhtrang 
						&& (this.tmpChiTietNK[i].LyDoChoPhepXuat == null || this.tmpChiTietNK[i].LyDoChoPhepXuat == '')){
					this.layoutUtilsService.showErorr('Vui lòng nhập lý do cho phép xuất kho cho mã hàng ' + this.tmpChiTietNK[i].MaHH);
					return null;
				}
			}
		}
		this.NKItem.listChiTietPhieuNhapKho = this.tmpChiTietNK;

		this.nhapKhoService.updateHHState(this.NKItem).subscribe(res => {
			if (res.status == 1){
				this.layoutUtilsService.showInfo('Cập nhật thành công');
				this.saveAddedNK.push(res.data.IdNk);
				this.isChange = true;
				this.back();
			}
			else{
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	isTrueButton(ROLENUMBER: string) {
		if (this.LIST_ROLES_USER.findIndex(x => x == ROLENUMBER) > -1) {
			return true;
		}
		return false;
	}
	exportExcel(){
		if(this.selection.selected.length == 0){
			this.layoutUtilsService.showErorr('Vui lòng chọn hàng để xuất file!');
			return;
		}

		if(this.selection.selected.length >= 2){
			for(let i = 0; i < this.selection.selected.length; i++){
				if(this.selection.selected[i].IdNcc != this.selection.selected[0].IdNcc
					|| this.selection.selected[i].IdKho != this.selection.selected[0].IdKho){

					this.layoutUtilsService.showErorr('Vui lòng chọn các mặt hàng cùng kho và cùng nhà cung cấp!');
					return;
				}
			}
		}

		if(this.NKItem.LoaiPhieu == 'Nhập kho hàng NCC giao'){
			this.dungChungService.getNCCById(this.selection.selected[0].IdNcc).subscribe( res => {
				if(res && res.status === 1) {

					var result = res.data;
					var listId: number[] = [];
					this.selection.selected.forEach(element =>{
						listId.push(element.IdCtdn);
					})
					this.nhapKhoService.getListGhiChu(listId).subscribe(resAPI =>{
						if(resAPI.status === 1){
							this.exportExcelInfo(result, resAPI.data);
						}
					})
				}
			});
		}
		else{
			this.exportExcelInfo(null)
		}
	}
	exportExcelInfo(nccInfo: any, ghichu: string = ''){

		

		let head = [['#', 'Mã hàng', 'Tên hàng', 'Số lô', 'Hạn sử dụng', 'Mã kho','ĐVT','Số lượng','Đơn giá','Thành tiền']]
		let dataTable =[{
			'#': 'A',
			'MaHH': 'B',
			'TenHH': 'C',
			'Solo': 'D',
			'HanSuDung': 'E',
			'MaKho': 'F',
			'TenDVT': 'G',
			'SL': '1',
			'DG': '2',
			'TT': '3'
		}];

		var total = 0;
		for(let i = 0; i < this.selection.selected.length; i++){
			let element = this.selection.selected[i]
			dataTable.push({
				'#' : (i + 2) + '',
				'MaHH': element.MaHH,
				'TenHH': element.TenHH,
				'Solo': element.Solo,
				'HanSuDung': element.Handung == null ? '' : this.getFormatDate(element.Handung),
				'MaKho': element.MaKho,
				'TenDVT': element.TenDVT,
				'SL': element.Soluongthucnhap,
				'DG': '',
				'TT': ''
			});
		}

		var dataRow = [];
		dataTable.forEach((element,index) =>{
			if(index == 0){
				dataRow.push([
					{content: element["#"], styles: { halign: 'center' }},
					{content: element.MaHH, styles: { halign: 'center' }},
					{content: element.TenHH, styles: { halign: 'center' }},
					{content: element.Solo, styles: { halign: 'center' }},
					{content: element.HanSuDung, styles: { halign: 'center' }},
					{content: element.MaKho, styles: { halign: 'center' }},
					{content: element.TenDVT, styles: { halign: 'center' }},
					{content: index == 0 ? '1' : '', styles: { halign: 'center' }},
					{content: index == 0 ? '2' : '', styles: { halign: 'center' }},
					{content: index == 0 ? '3' : '', styles: { halign: 'center' }},
				])
			}
			else{
				dataRow.push([
					{content: index, styles: { halign: 'center' }},
					{content: element.MaHH, styles: { halign: 'left' }},
					{content: element.TenHH, styles: { halign: 'left' }},
					{content: element.Solo, styles: { halign: 'left' }},
					{content: element.HanSuDung, styles: { halign: 'left' }},
					{content: element.MaKho, styles: { halign: 'left' }},
					{content: element.TenDVT, styles: { halign: 'left' }},
					{content: this.f_currency(this.formatNumber(element.SL)), styles: { halign: 'right' }},
					{content: ''},
					{content: ''},
				])
			}
		})
		dataRow.push([
			{content: (''), styles: { halign: 'center' }},
			{content:'Cộng', colSpan: 5, styles: { halign: 'center', fontStyle: 'bold', } }, 
			{content:''},
			{content:''},
			{content: `${total == 0 ? '' : this.f_currency(this.formatNumber('' + total))}`}
		])

		var doc = new jsPDF();
		this.pdfCustomService.AddFontRoboto(doc);
		let x = 10; let y = 15;
		var xOffset = (doc.internal.pageSize.width / 2 - 10);

		doc.setFontSize(10);
		doc.setFontType("normal");
		doc.text(x,y, 'CÔNG TY TNHH THỰC PHẨM NFC');
		y += 7;
		doc.text(x,y, 'Đường số 8, KCX Nhơn Trạch 1, xã Phước Thiên, huyện Nhơn Trạch, tỉnh Đồng Nai, Việt Nam');
		y += 12;

		doc.setFontType("bold");
		doc.setFontSize(12);
		var textWidth = doc.getStringUnitWidth('PHIẾU NHẬP KHO') * doc.internal.getFontSize() / doc.internal.scaleFactor;
		var textOffset = (doc.internal.pageSize.width - textWidth) / 2;
		doc.text(textOffset, y, 'PHIẾU NHẬP KHO');
		y += 7;

		doc.setFontSize(10);
		doc.setFontType("bolditalic");
		var formatDate = this.getFormatDate(this.NKItem.Ngaynhapkho).split("/")
		var textWidth = doc.getStringUnitWidth('Ngày ' + formatDate[0] + ' tháng ' + formatDate[1] + ' năm ' + formatDate[2]) * doc.internal.getFontSize() / doc.internal.scaleFactor;
		var textOffset = (doc.internal.pageSize.width - textWidth) / 2;
	
		doc.text(textOffset, y, 'Ngày ' + formatDate[0] + ' tháng ' + formatDate[1] + ' năm ' + formatDate[2]);
		doc.setFontType("normal");
		doc.text(160, y, 'TK nợ:');
		y += 7;
		var textWidth = doc.getStringUnitWidth('Số: ' + this.NKItem.Sophieu) * doc.internal.getFontSize() / doc.internal.scaleFactor;
		var textOffset = (doc.internal.pageSize.width - textWidth) / 2;
		doc.text(textOffset, y, 'Số: ' + this.NKItem.Sophieu);
		doc.text(160, y, 'TK có:');
		y += 12;

		doc.text(x,y, '- Họ và tên người giao hàng: ');
		if(nccInfo != null && nccInfo != undefined){
			doc.text(x + 50,y, nccInfo.NguoiDaiDien);
		}
		y += 7;

		doc.text(x,y, '- Địa chỉ: ');
		if(nccInfo != null && nccInfo != undefined){
			doc.text(x + 15,y, nccInfo.DiaChi); 
		}
		y += 7;

		doc.text(x,y, '- Mã số thuế: ');
		if(nccInfo != null && nccInfo != undefined){
			doc.text(x + 22,y, nccInfo.MST); 
		}
		y += 7;

		doc.text(x,y, '- Diễn giải: ' + this.NKItem.DienGiai); y += 7;
		doc.text(x,y, '- Theo');
		doc.text(x + 60,y, 'ngày');
		doc.text(x + 80,y, 'tháng');
		doc.text(x + 100,y, 'năm');
		doc.text(x + 120,y, 'của');y += 7;
		doc.text(x,y, '- Nhập tại kho: ' + this.tmpChiTietNK[0].TenKho);

		y +=10;
		(doc as any).autoTable({
			head: head,
			body: dataRow,
			styles: { 
				font: 'Roboto-Regular',
      			fontStyle: 'normal',
				fontSize: 10, 
			},
			headStyles:{
				font: 'Roboto-Regular',
				fontStyle: 'bold',
				fontSize: 11,
			},
			margin: { top: y, left: 10 },
			theme: 'grid'
		})
		y +=15 + ((dataRow.length + 1)*10);

		doc.text(x,y, '- Số tiền bằng chữ: ');
		doc.setFontType("italic");
		if(total > 0){
			doc.text(x + 30,y, FunctionPublic.convertCurrencyFromNumToStr(total.toString()));
		}
		y += 7;

		doc.text(x,y, '- Số chứng từ gốc kèm theo: ' + ghichu); y += 10;

		var toDay = new Date();
		var d = toDay.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }).split("/");
		doc.text(x + 140, y, 'Ngày ' + d[1] + ' tháng ' + d[0] + ' năm ' + d[2]); y += 7;

		doc.setFontType("bold");
		doc.text(20, y, 'Người lập phiếu');
		doc.text(70, y, 'Người giao hàng');
		doc.text(120, y, 'Thủ kho');
		doc.text(160, y, 'Kế toán trưởng');y += 7;
		
		doc.setFontType("normal");
		doc.text(24, y, '(Ký, họ tên)');
		doc.text(74, y, '(Ký, họ tên)');
		doc.text(118, y, '(Ký, họ tên)');
		doc.text(163, y, '(Ký, họ tên)');;y += 40;

		doc.text(20, y, this.NKItem.TenNguoitao);

		// Download PDF document  
		doc.save(this.NKItem.Sophieu + '_Report.pdf');
	}
	checkWarningState(item: ChiTietPhieuNhapKho){
		var tmp = Number(item.Soluongchungtu) * item.DungSai / 100;
		var result = -1;

		if(Number(item.Soluongthucnhap) > Number(item.Soluongchungtu) + tmp){
			result = 0;
		}
		if((Number(item.Soluongchungtu) - tmp) <= Number(item.Soluongthucnhap)
		&& (Number(item.Soluongthucnhap) <= Number(item.Soluongchungtu) + tmp)){
			result = 1;
		}
		if(Number(item.Soluongthucnhap) < Number(item.Soluongchungtu) - tmp){
			result = 2;
		}
		return result;
	}
	warningState(item: ChiTietPhieuNhapKho ){
		let result = this.checkWarningState(item);
		switch(result){
			case 0:
				return '> dung sai cho phép';
			case 1:
				return 'Thuộc dung sai cho phép';
			case 2:
				return '< dung sai cho phép';
			default:
				return ''
		}
	}
	cssWarningState(item:ChiTietPhieuNhapKho){
		let result = this.checkWarningState(item);
		switch(result){
			case 0:
				return 'red';
			case 1:
				return 'green';
			case 2:
				return 'orange';
			default:
				return ''
		}
	}
	/*------------------------------------------------------------- */

	/*
		Hàm hỗ trợ tổ hợp phím trên form
	*/
	onKeydownMain(event :KeyboardEvent) {
		//Tham khảo keyCode của event theo link: https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
	}
	focusEvent(){
		if(this.focus != null && this.focus != undefined){
			setTimeout(() => this.focus.first.nativeElement.focus(), 500);
			this.changeDetect.detectChanges();
		}
	}
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	/*------------------------------------------------------------- */
}